// 客户费率模板

import { HttpInboundBillClientList } from '@/service/inbound';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tabs: { show: true },
            formData: {
                isManage: true,
                "search[IN_inboundPlanOrderStatus]": "20,25"
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpInboundBillClientList,
        interceptRequest(data) {
            const warehouseId = data.search.warehouseId;
            data.warehouseId = warehouseId;
            delete data.search.warehouseId;
            return data
        },
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getBillcusWareList']),
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: "入库计划单号" }),
                    key: 'EQ_inboundPlanOrderNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'warehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "Shipment ID",
                    key: 'EQ_shipmentId',
                    tag: 'vInput',
                },
                {
                    label: "Reference ID",
                    key: 'EQ_referenceId',
                    tag: 'vInput',
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: 'inboundPlanOrderNo',
                }, {
                    title: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                }, {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineName',
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'inboundPlanOrderStatus',
                    render: (h, { row }) => {
                        const status = row.inboundPlanOrderStatus;
                        const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{status ? label : this.$t('fbb.headlogistics.draft', { defaultValue: '草稿' })}</vButton>
                    }
                }, {
                    title: 'Shipment ID',
                    key: 'shipmentId',
                }, {
                    title: 'Reference ID',
                    key: 'referenceId',
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 90,
                    align: 'center',
                    render: (h, { row }) => {
                        return <vButton theme='primary' onClick={this.handleOperates.bind(this, row)}>{this.$t('fbb.inbound.choose', { defaultValue: '选择' })}</vButton>
                    }
                }];
        },
    },
};




